





































import "./tracking-filter.less";
import Vue from "vue";
import { mapState, mapGetters } from "vuex";

export default Vue.extend({
  name: "tracking-filter",
  props: {
    showValueFormatOptions: {
      default: true,
      type: Boolean,
    },
  },
  data() {
    return {
      showFilterPoptip: false,
      valueFormat: "both",
    };
  },
  computed: {
    ...mapState("goal", ["loading", "currentGoal", "dateFilter", "currentGoalTrackingMembers"]),
    targetUserFilter: {
      get() {
        return (this as any).$store.state.goal.targetUserFilter;
      },
      set(newValue) {
        (this as any).$store.dispatch("goal/setTargetUserFilter", newValue);
        (this as any).$emit("filter", {});
      },
    },
  },
  watch: {
    valueFormat(newValue) {
      (this as any).$emit("value-format-changed", newValue);
    },
  },
  methods: {
    handleRefreshClick() {
      let goal = (this as any).currentGoal;
      if (goal) {
        this.$store.dispatch("goal/get", { id: goal.id });
      }
    },
  },
});
